import { yupResolver } from '@hookform/resolvers/yup';
import Stack from '@mui/material/Stack';
import React from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { object, string } from 'yup';

import MfaFormDefaultValues from '../../formDefaultValues/MfaFormDefaultValues';
import { ControlledTextInput } from '../ControlledTextInput';
import { Item } from '../Item';
import { WsButton } from '../WsButton';

const validationSchema = object().shape({
  mfa: string().required('Please enter an MFA code to complete sign-in'),
});
interface IMfaForm {
  handleMFA(args: string): void;
}

const MfaForm: React.FC<IMfaForm> = ({ handleMFA }) => {
  const formOptions = {
    resolver: yupResolver(validationSchema),
    defaultValues: MfaFormDefaultValues,
  };

  const methods = useForm(formOptions);

  const { handleSubmit } = methods;

  const submitMFA = (data: { mfa: string }) => {
    handleMFA(data.mfa);
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(submitMFA)}>
        <Item>
          <Stack spacing={2} direction="column">
            <ControlledTextInput
              name={'mfa'}
              labelText="Multi-factor Authentication"
              sx={{ marginTop: '12px' }}
              fullWidth={true}
              id="mfa-code"
              placeholder="Please enter an MFA code to complete sign-in"
              variant="outlined"
              required
              autoComplete="mfa"
            />
          </Stack>
          <Stack mt={2}>
            <WsButton variant="contained" size="large" fullWidth type="submit">
              Log In
            </WsButton>
          </Stack>
        </Item>
      </form>
    </FormProvider>
  );
};

export default MfaForm;
